import React, { useEffect } from "react";
import "./header.scss";
import {appConfig} from "./../../appConfig";
// import NotificationsIcon from "@material-ui/icons/Notifications";
// import UnitCalculator from "./unitcalculator/unitCalculator";
import ProfileDropdown from "./profileDropdown";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { useHistory, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";
import * as miscAction from "../../actions/miscAction"
const Header = ({ permission,bredCrumbData,breadCrumbInStore,breadCrumbSettingAction,miscState,modelState,onModelSelected,userRole }) => {
  const history = useHistory();
  const routeTo = useRouteMatch();
  useEffect(() => {
    console.log('testing breadcrumb',breadCrumbInStore);
  },[breadCrumbInStore])
  const onBredCumbClick = async(index,bredCrumb) => {
    if(index == 0){
      if(userRole === "ADMIN"){
        await onModelSelected("ADMIN");
        await breadCrumbSettingAction(localStorage.getItem("userName"));
        history.push("/licenseManager/admin/regions");
      }
      else if(userRole === "REGION"){
        await onModelSelected("REGION");
        await breadCrumbSettingAction(localStorage.getItem('userName'));
        const regionStoredId = localStorage.getItem("regionIdValue");
        history.push(`/licenseManager/region/regionsLevel/${regionStoredId}`)
      }
      else{
        history.push(`#`);
      }
    }
    else if(index == 1){
      if(userRole === "ADMIN"){
        await onModelSelected("REGION");
        await breadCrumbSettingAction(`${localStorage.getItem("userName")} > ${bredCrumb}`);
        const regionStoredId = localStorage.getItem("regionIdValue");
        history.push(`/licenseManager/region/regionsLevel/${regionStoredId}`)
      }
      else if(userRole === "REGION"){
        await onModelSelected("SALES_OFFICE");
        await breadCrumbSettingAction(`${localStorage.getItem("userName")} > ${bredCrumb}`);
        const salesOfficeStoredId = localStorage.getItem("salesOfficeValue");
        history.push(`/licenseManager/office/customers/${salesOfficeStoredId}`)
      }
      else{
        history.push(`#`)
      }
    }
  }
  var breadCrumbArray = [];
  if(!bredCrumbData.includes(">")){
    breadCrumbArray.push(bredCrumbData);
  }
  else{
    breadCrumbArray = bredCrumbData.split(" > ").map(item => item.trim())
  }
  return (
    <>
      <header>
        <div className="container">
          <div className="header-wrapper">
            <div className="brand-logo">
              <a className="drawing-manager-logo" href={appConfig.postLogOutUri}>eDesign License Manager</a>
            </div>
            <div className="user-role">
              <span className="role-text">
                  {breadCrumbArray.map((bredCrumb,index) => (
                    <span
                      key={index}
                      onClick={() => onBredCumbClick(index,bredCrumb)}
                      style={{cursor:"pointer"}}
                    >
                      {bredCrumb}
                      {index < breadCrumbArray.length - 1 && " > "}
                    </span>
                  ))}
              </span>
            </div>
            <div className="header-right-content">
              <nav className="dropdown-right">
                {/* <UnitCalculator /> */}
                <Tooltip>
                  <IconButton
                    disabled={true}
                    role="button"
                    className="dropdown-toggler"
                    onClick={(e)=>{}}
                    style={{padding:0, color:"#fff"}}
                  >
                    {/* <NotificationsIcon /> */}
                  </IconButton>
                </Tooltip>
                {/* <NotificationsList/> */}
                <ProfileDropdown permission={permission} />
              </nav>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

const mapStateToProps = (state) => ({
  modelState: state.model,
  miscState: state.misc,
  breadCrumbInStore: state.misc.bredCrumb,
  userRole: state.loggedInUserInfo.loggedInUserInfo?.userRole || null,
});

const mapDispatchToProps = (dispatch) => {
  return {
    breadCrumbSettingAction: async(breadCrumb) => dispatch(miscAction.breadCrumbSettingAction(breadCrumb)),
    onModelSelected: async(modelType) => dispatch(miscAction.onModelSelected(modelType)),
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(Header);
